<div class="filupload-container">
  <p-fileUpload  [auto]="true" [multiple]="multiple" customUpload="true"
  [accept] = "ImageOnly ? 'image/*' : 'image/*,application/pdf,text/*,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,
  application/vnd.openxmlformats-officedocument.wordprocessingml.document,
  application/vnd.ms-powerpoint,
  application/vnd.openxmlformats-officedocument.presentationml.presentation,
  application/msword'"
            
   invalidFileTypeMessageSummary="Invalid File Type!" 
    invalidFileTypeMessageDetail="This file type is not allowed to upload."
    (uploadHandler)="customOnFileUpload($event)" [maxFileSize]="maxFileSize" [files]="currentFiles"
    [disabled]="disabled" chooseLabel="Browse">
    <ng-template pTemplate="content" *ngIf="!disabled">
      <span>Drag or Drop files here</span>
    </ng-template>
  </p-fileUpload>
  <div class="file-upload-box">
    <div class="preview-wrapper" *ngFor="let file of inputFiles" type="none">
      <span class="preview">
        <img [style.width]="previewWidth" [src]="file.objectURL || file.FilePath" class="img-preview"
          alt="no preview available"></span>
      <span class="preview-file"><label class="checkbox-inline">{{file.name}}</label></span>
      <span class="preview-action" *ngIf="!disabled"><button icon="fa fa-close" pButton type="button"
          (click)="removeFile(file)"></button></span>
    </div>
  </div>
</div>
